module.exports = __webpack_public_path__ + "img/1557614066381430786.07786fb8.png";